import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { YieldType } from '../../../enums/yield-type.enum'
import { Yield } from '../../../interfaces/yield.interface'
import { EmptyPlaceHolderPipe } from '../../../standalone-exports'
import { AnalogProgressBarYieldComponent } from '../analog-progress-bar-yield/analog-progress-bar-yield.component'
import { ColorYieldComponent } from '../color-yield/color-yield.component'
import { CurrencyYieldComponent } from '../currency-yield/currency-yield.component'
import { DateYieldComponent } from '../date-yield/date-yield.component'
import { DatetimeYieldComponent } from '../datetime-yield/datetime-yield.component'
import { DownloadYieldComponent } from '../download-yield/download-yield.component'
import { FileIconYieldComponent } from '../file-icon-yield/file-icon-yield.component'
import { IconYieldComponent } from '../icon-yield/icon-yield.component'
import { ImageYieldComponent } from '../image-yield/image-yield.component'
import { ProgressBarYieldComponent } from '../progress-bar-yield/progress-bar-yield.component'
import { SwitchYieldComponent } from '../switch-yield/switch-yield.component'
import { TextYieldComponent } from '../text-yield/text-yield.component'

@Component({
    selector: 'case-yield',
    templateUrl: './case-yield.component.html',
    styleUrls: ['./case-yield.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ImageYieldComponent,
        DateYieldComponent,
        DatetimeYieldComponent,
        CurrencyYieldComponent,
        DownloadYieldComponent,
        ColorYieldComponent,
        FileIconYieldComponent,
        IconYieldComponent,
        ProgressBarYieldComponent,
        AnalogProgressBarYieldComponent,
        SwitchYieldComponent,
        TextYieldComponent,
        EmptyPlaceHolderPipe
    ]
})
export class CaseYieldComponent {
  @Input() yield: Yield

  YieldType = YieldType
}
